import { useState } from "react";
import { HiX } from "react-icons/hi";
import { HiOutlineBars3 } from "react-icons/hi2";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const NAV_LINKS = [
    { to: "/", label: "Home" },
    { to: "#features", label: "Features" },
    { to: "/docs", label: "API Docs" },
    // { to: "#pricing", label: "Pricing" },
    { to: "/contact", label: "Contact" },
] as const;


export default function Navbar() {
    const navigate = useNavigate();
    const location = useLocation();

    const [isOpen, setIsOpen] = useState(false);
    const handleScroll = (id: string) => {
        if (location.pathname !== "/") {
            navigate(`/#${id}`);
            return;
        }

        document.getElementById(id)?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });

        setIsOpen(false);
    };

    const linkClass = ({ isActive }: { isActive: boolean }) =>
        `text-sm transition-colors hover:text-web-secondary ${isActive ? "text-web-secondary font-medium" : ""
        }`;

    return (
        <header className="w-full bg-white">
            <div className="px-6 lg:px-24 py-4 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-2 shrink-0">
                    <img
                        src="/images/whtsappLogo.svg"
                        alt="Company logo"
                        className=""
                    />
                    <span className="text-[18px] font-semibold text-black">
                        Empedance
                    </span>
                </Link>

                <nav
                    aria-label="Main navigation"
                    className="hidden lg:flex items-center gap-10"
                >
                    {NAV_LINKS.map(({ to, label }) => {
                        if (to.startsWith("#")) {
                            return (
                                <button
                                    key={to}
                                    onClick={() => handleScroll(to.replace("#", ""))}
                                    className="
                                        relative inline-block text-sm transition-colors hover:text-web-secondary
                                        after:absolute after:left-1/2 after:-translate-x-1/2
                                        after:bottom-[-4px] after:h-[2px] after:w-0
                                        after:bg-web-secondary after:transition-all after:duration-700
                                        hover:after:w-full
                                    "
                                >
                                    {label}
                                </button>
                            );
                        }

                        return (
                            <NavLink
                                key={to}
                                to={to}
                                className={({ isActive }) =>
                                    `relative inline-block text-sm transition-colors hover:text-web-secondary
                                    after:absolute after:left-1/2 after:-translate-x-1/2
                                    after:bottom-[-4px] after:h-[2px] after:w-0
                                    after:bg-web-secondary after:transition-all after:duration-700
                                    hover:after:w-full
                                    ${isActive ? "text-web-secondary font-medium after:w-full" : ""}`
                                }
                            >
                                {label}
                            </NavLink>
                        );
                    })}
                </nav>

                <div className="hidden lg:flex items-center gap-6">
                    <Link
                        to="/login"
                        target="blank"
                        rel="noopener noreferrer"
                        className="text-sm hover:text-web-secondary transition-colors"
                    >
                        Sign In
                    </Link>

                    <Link
                        to="/login"
                        target="blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center rounded-xl bg-web-primary px-4 py-2 text-sm
                       font-medium shadow-web-glow transition-all"
                    >
                        Get Started
                    </Link>
                </div>

                {/* Mobile Hamburger */}
                <button
                    type="button"
                    className="lg:hidden shrink-0 p-2"
                    aria-label={isOpen ? "Close menu" : "Open menu"}
                    aria-expanded={isOpen}
                    onClick={() => setIsOpen((prev) => !prev)}
                >
                    {isOpen ? (
                        <HiX className="h-6 w-6" />
                    ) : (
                        <HiOutlineBars3 className="h-6 w-6" />
                    )}
                </button>
            </div>

            {/* Mobile Dropdown */}
            {isOpen && (
                <nav
                    aria-label="Mobile navigation"
                    className="lg:hidden flex flex-col gap-4 px-6 pb-6"
                >
                    {NAV_LINKS.map(({ to, label }) => {
                        if (to.startsWith("#")) {
                            return (
                                <button
                                    key={to}
                                    onClick={() => handleScroll(to.slice(1))}
                                    className="text-left text-sm transition-colors hover:text-web-secondary"
                                >
                                    {label}
                                </button>
                            );
                        }

                        return (
                            <NavLink
                                key={to}
                                to={to}
                                end={to === "/"}
                                className={linkClass}
                                onClick={() => setIsOpen(false)}
                            >
                                {label}
                            </NavLink>
                        );
                    })}

                    <hr className="my-2" />

                    <Link
                        to="/login"
                        className="text-sm hover:text-web-secondary transition-colors"
                        onClick={() => setIsOpen(false)}
                    >
                        Sign In
                    </Link>

                    <Link
                        to="/login"
                        className="flex items-center justify-center rounded-xl bg-web-primary px-4 py-2 text-sm
                       font-medium shadow-web-glow transition-all"
                        onClick={() => setIsOpen(false)}
                    >
                        Get Started
                    </Link>
                </nav>
            )}
        </header>
    );
}